export default {
    name: process.env.REACT_APP_NAME || 'EPOS',
}